import {
  HIDE_APP_LOADER,
  SET_CLIENT_APPS,
  SET_APPLICATIONS,
  SET_APP_CLEAR,
  SET_APP_DATA,
  SHOW_APP_LOADER,
  SET_APP_DATA_NULL,
  SET_APP,
} from "./actionType";

const INIT_STATE = {
  data: {
    count: 0,
    next: null,
    previous: null,
    page: 1,
    sizePerPage: 100,
    results: [],
  },
  app_data: null,
  apps: {
    count: 9999,
    next: null,
    previous: null,
    page: 1,
    sizePerPage: 10,
    results: [],
  },
  app: null,
  loading: false,
  error: null,
};

const Apps = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_APPLICATIONS:
      return {
        ...state,
        data: action.payload,
      };
    case SET_CLIENT_APPS:
      return {
        ...state,
        apps: action.payload,
      };
    case SET_APP_CLEAR:
      return {
        ...state,
        apps: null,
      };
    case SET_APP:
      return {
        ...state,
        app: action.payload,
      };
    case SET_APP_DATA_NULL:
      return {
        ...state,
        app_data: null,
      };
    case SET_APP_DATA:
      return {
        ...state,
        app_data: action.payload,
      };
    case SHOW_APP_LOADER:
      return {
        ...state,
        loading: true,
      };
    case HIDE_APP_LOADER:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};

export default Apps;
